import { Box } from '@mui/material';
import React from 'react';

const ReceiptIcon: React.FC<Props> = ({
  children,
  className,
  size = 'is-normal',
  variant = 'is-primary',
  isLight = false,
  fullWidth,
  backgroundColor,
  color,
  status,
  ...props
}) => {
  return (
    <Box style={{ display: 'inline-flex', alignItems: 'center' }}>
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.3993 1.26685C19.2513 1.23168 19.0957 1.25066 18.9606 1.32037L18 1.80006L17.0313 1.31568C16.9445 1.2723 16.8488 1.24971 16.7518 1.24971C16.6548 1.24971 16.5591 1.2723 16.4723 1.31568L15.4914 1.80045L14.5235 1.31568C14.4364 1.27198 14.3404 1.24922 14.243 1.24922C14.1456 1.24922 14.0496 1.27198 13.9625 1.31568L13 1.79889L12.045 1.31685C11.9582 1.27285 11.8623 1.24972 11.765 1.24932C11.6676 1.24891 11.5716 1.27123 11.4844 1.31451L10.5 1.80084L9.53129 1.31529C9.44436 1.27193 9.34855 1.24935 9.2514 1.24935C9.15426 1.24935 9.05845 1.27193 8.97152 1.31529L8.00004 1.80006L7.02972 1.31529C6.90463 1.25259 6.76212 1.23367 6.62501 1.26158C6.48789 1.28948 6.36411 1.36259 6.27347 1.4692C6.17579 1.58563 6.12312 1.73324 6.12504 1.88521V11.2493L6.12699 11.2512H13.625C13.9566 11.2512 14.2745 11.3829 14.5089 11.6173C14.7433 11.8518 14.875 12.1697 14.875 12.5012V16.5618C14.875 17.77 16.1668 18.7493 17.375 18.7493H17.8438C18.3825 18.7493 18.8992 18.5353 19.2801 18.1543C19.661 17.7734 19.875 17.2567 19.875 16.718V1.87428C19.8751 1.73439 19.8283 1.59851 19.7421 1.48838C19.6558 1.37826 19.5351 1.30025 19.3993 1.26685ZM16.75 9.37428H11.7696C11.4321 9.37428 11.1407 9.1149 11.1258 8.7774C11.122 8.69306 11.1353 8.60881 11.165 8.52976C11.1947 8.45071 11.24 8.37848 11.2984 8.31745C11.3567 8.25641 11.4268 8.20782 11.5044 8.17462C11.5821 8.14142 11.6656 8.1243 11.75 8.12428H16.7305C17.068 8.12428 17.3594 8.38365 17.3743 8.72115C17.3781 8.8055 17.3647 8.88974 17.3351 8.96879C17.3054 9.04784 17.2601 9.12007 17.2017 9.18111C17.1434 9.24215 17.0733 9.29073 16.9956 9.32393C16.918 9.35713 16.8345 9.37426 16.75 9.37428ZM16.75 6.24928H9.26957C8.93207 6.24928 8.64066 5.9899 8.62582 5.6524C8.62202 5.56806 8.63535 5.48381 8.665 5.40476C8.69466 5.32571 8.74002 5.25348 8.79836 5.19245C8.85669 5.13141 8.92679 5.08282 9.00442 5.04962C9.08205 5.01642 9.1656 4.9993 9.25004 4.99928H16.7305C17.068 4.99928 17.3594 5.25865 17.3743 5.59615C17.3781 5.6805 17.3647 5.76474 17.3351 5.84379C17.3054 5.92284 17.2601 5.99507 17.2017 6.05611C17.1434 6.11714 17.0733 6.16573 16.9956 6.19893C16.918 6.23213 16.8345 6.24926 16.75 6.24928Z"
          fill="#4684E7"
        />
        <path
          d="M13.625 16.5625V13.125C13.625 12.9592 13.5592 12.8003 13.4419 12.6831C13.3247 12.5658 13.1658 12.5 13 12.5H2.375C2.04346 12.501 1.72582 12.6333 1.49157 12.8679C1.25731 13.1026 1.12551 13.4204 1.125 13.752C1.125 15.7266 1.35078 16.5477 1.68984 17.1727C2.26523 18.234 3.30703 18.75 4.875 18.75H14.4719C14.5027 18.75 14.5329 18.7409 14.5585 18.7239C14.5842 18.7068 14.6042 18.6825 14.6161 18.6541C14.628 18.6256 14.6313 18.5943 14.6254 18.564C14.6195 18.5338 14.6049 18.5059 14.5832 18.484C14.2137 18.1133 13.625 17.6172 13.625 16.5625Z"
          fill="#4684E7"
        />
      </svg>
    </Box>
  );
};
export type IconVariant =
  | 'is-black'
  | 'is-dark'
  | 'is-light'
  | 'is-white'
  | 'is-primary'
  | 'is-link'
  | 'is-info'
  | 'is-success'
  | 'is-warning'
  | 'is-danger'
  | 'is-customize';

export type Props = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLOrSVGElement>,
  HTMLOrSVGElement
> & {
  variant?: IconVariant;
  isLight?: boolean;
  size?: 'is-normal' | 'is-medium' | 'is-large';
  fullWidth?: boolean;
  backgroundColor?: string;
  color?: string;
  className?: string;
  status?: string;
};
export default ReceiptIcon;
